<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  @use "../../../../assets/css/_mixins.scss" as *;
  .nameWrapper {
    height: 2.5rem;
    display: flex;
    align-items: center;
    gap: 1rem;

    .ranking {
      background-color: $light-blue;
      border-radius: 0.25rem;
      color: $blue;
      @include size(2.5rem);
      @include flex-center;
      @extend .text-body-1-bold;
    }

    .name {
      overflow: hidden;
      max-width: 100px;
      line-height: 1.2;
      @extend .text-body-2;
    }

    &.isCurrentUser {
      .ranking {
        background-color: $blue;
        color: white;
      }

      .name {
        color: $blue;
        font-weight: bold;
      }
    }
  }
</style>

<script>
  import Avatar from "../../components/legacy/Avatar.svelte";
  import IconContainer from "../../components/legacy/IconContainer.svelte";

  export let showRanking = false;
  export let ranking = 0;
  export let prioritizeCurrentUser = false;
  export let user = { isCurrentUser: false, image: "", name: "", href: "" };
  export let displayAsIcon = false;

  const iconMap = {
    Clicks: "clicks",
    Opens: "opens",
    Replies: "replies",
    Interested: "interested",
    Meetings: "meetings",
  };
  $: name =
    prioritizeCurrentUser && user.isCurrentUser ? "My Stats" : user.name;
</script>

<div class="nameWrapper" class:isCurrentUser={user.isCurrentUser}>
  {#if showRanking}
    <div class="ranking">
      {ranking + 1}
    </div>
  {/if}
  {#if displayAsIcon}
    <IconContainer icon={iconMap[user.name]} size="md" />
  {:else}
    <Avatar size="lg" image={user.image} name={user.name} displayInitials />
  {/if}
  <div class="name">
    {#if user.href}
      <a href={user.href} target="_blank">{name}</a>
    {:else}
      <span>{name}</span>
    {/if}
  </div>
</div>
